import APIRequest from '@/api'
import { useAuthStore } from '@/stores/login'
import { useUsersStore } from '@/stores/users'
import type { UserInfo } from '@/api/Models/UserInfo'

export const updateUserInfo = async () => {
  const res = await APIRequest.User.getUserInfo()
  const { code, data } = res
  if (code === 1) {
    const authStore = useAuthStore()
    const usersStore = useUsersStore()
    const { setUserId, setTeamStudy, setUserAuth, setDeptId } = authStore
    const { setCollegeId } = usersStore
    setTeamStudy(0)
    setDeptId(data?.deptId as string)
    setUserAuth({
      teamLearningLabel: 0,
      teachingMgtLabel: 0,
    })

    setTeamStudy(data?.sysUserLabel?.teamLearningLabel as number)
    setUserAuth({
      teamLearningLabel: data?.sysUserLabel?.teamLearningLabel as number,
      teachingMgtLabel: data?.sysUserLabel?.teachingMgtLabel as number
    })
    setUserId(data.id)
    setCollegeId(data.collegeId)
  }
}
